// removed by extract-text-webpack-plugin
module.exports = {"root":"wallet_root_dch22t"};


//////////////////
// WEBPACK FOOTER
// ./packages/page-index/src/wallet.scss
// module id = 595
// module chunks = 0